import React from 'react'

import classNames from 'classnames'
import styled from 'styled-components'

import { IconProps } from '@customTypes'

import { ClickableIconWrapper } from './components'
import { notebook } from './notebook/notebook'

const IconComponent: React.FC<IconProps> = ({
  onClick,
  onMouseDown,
  isDisabled,
  title,
  className,
  'aria-label': ariaLabel,
  icon,
  ...props
}) => {
  const SVGComponent = notebook[icon]

  return typeof onClick === 'function' || typeof onMouseDown === 'function' ? (
    <ClickableIconWrapper
      isDisabled={isDisabled}
      onMouseDown={onMouseDown}
      onClick={onClick}
      title={title}
      className={classNames('icon--centivo', className)}
      aria-label={ariaLabel}
      aria-disabled={isDisabled}
      type="button"
    >
      <SVGComponent role="img" {...props} />
    </ClickableIconWrapper>
  ) : (
    <SVGComponent
      role="img"
      {...props}
      aria-label={ariaLabel}
      className={classNames('icon--centivo', className)}
    />
  )
}

export const Icon = styled(IconComponent)``

Icon.displayName = 'CentivoIcon'
